import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import {
    FORGOT_PASSWORD,
    RETURN_TO_LOGIN,
    UPDATE_EMAIL,
    VERIFICATION_CODE_RECEIVED,
    VERIFICATION_SEND_SUCCESS,
    STORE_USER,
    LOGIN_FAILURE,
    GET_README_TOKEN_SUCCESS,
    GET_README_TOKEN_LOAD,
    GET_README_TOKEN_FAILURE
} from './loginActions';
import { getViewStateByName } from '../appViewStates';

export default function reducer(state = {
    email: '', validationErrors: [], verificationCode: '', readmeToken: ''
}, action = {}) {
    let newState;

    switch (action.type) {
        case FORGOT_PASSWORD:
            newState = {
                ...state,
                view: 'forgotPassword'
            };

            return isEqual(state, newState) ? state : newState;

        case RETURN_TO_LOGIN:

            newState = {
                ...state,
                view: ''
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_EMAIL:
            newState = {
                ...state,
                email: action.text
            };

            return isEqual(state, newState) ? state : newState;

        case VERIFICATION_CODE_RECEIVED:
            newState = {
                ...state,
                view: 'updatePassword'
            };

            return isEqual(state, newState) ? state : newState;

        case VERIFICATION_SEND_SUCCESS:
            newState = {
                ...state,
                view: 'confirmVerificationCodeReceived'
            };

            return isEqual(state, newState) ? state : newState;

        case STORE_USER:
            newState = {
                ...state,
                user: action.user
            };

            return isEqual(state, newState) ? state : newState;

        case LOGIN_FAILURE:
            newState = {
                ...state,
                user: null
            };

            return isEqual(state, newState) ? state : newState;

        case GET_README_TOKEN_SUCCESS:
            newState = {
                ...state,
                readmeToken: action.message,
                readmeTokenLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        case GET_README_TOKEN_LOAD:
            newState = {
                ...state,
                readmeTokenLoading: true
            };

            return isEqual(state, newState) ? state : newState;

        case GET_README_TOKEN_FAILURE:
            newState = {
                ...state,
                error: action.error,
                readmeTokenLoading: false
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getLoginViewState = createSelector(
    (state) => state,
    (state) => getViewStateByName(state, 'login')
);

export const getUser = createSelector(
    getLoginViewState,
    (viewState) => get(viewState, 'user')
);

export const getEmail = createSelector(
    getLoginViewState,
    (viewState) => get(viewState, 'email')
);

export const getLoginView = createSelector(
    getLoginViewState,
    (viewState) => get(viewState, 'view')
);

export const getVerificationCode = createSelector(
    getLoginViewState,
    (viewState) => get(viewState, 'verificationCode')
);

export const getReadmeToken = createSelector(
    getLoginViewState,
    (viewState) => get(viewState, 'readmeToken')
);

export const getIsReadmeTokenLoading = createSelector(
    getLoginViewState,
    (viewState) => get(viewState, 'readmeTokenLoading')
);

export const getReadmeTokenError = createSelector(
    getLoginViewState,
    (viewState) => get(viewState, 'error')
);

export const getReadmeTokenErrorMessage = createSelector(
    getReadmeTokenError,
    (error) => get(error, 'message')
);
